export default "__VITE_ASSET__21c45d06__"